import React from 'react';
import { useDebug } from '../hooks';
import AddToCartArea from "./AddToCartArea";

const SimpleProduct = ({context}: any) => {
  
    const props: any = React.useContext(context);
    useDebug(`SimpleProduct [${props.name}]`)

    return (<>
      <AddToCartArea {...props} />
    </>)
}

export default SimpleProduct;